import { useEffect, useState } from 'react'
import { useAppSelector } from '@shared/lib/redux'

import { mapStore } from './map.slice'

export const useMapConfig = () => {
  return {
    ...useAppSelector(mapStore.selectors.selectMapCommon)
  }
}

export const useMapBounds = () => {
  return {
    ...useAppSelector(mapStore.selectors.selectMapBounds)
  }
}

export const useIsDrawingMode = () => {
  return useAppSelector(mapStore.selectors.selectDrawingMode)
}

export const useMaterialIconsFont = () => {
  const [isIconFontLoaded, setIconFontLoaded] = useState<boolean>(false)

  /** Прнудительная закачка шрифта с иконками Material UI при первом размещении компонента */
  const loadMaterialIconsFontOnStart = async (): Promise<void> => {
    const materialFont = new FontFace(
      'Material Icons',
      'url(https://fonts.gstatic.com/s/materialicons/v48/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2)'
    )
    document.fonts.add(materialFont)
    try {
      await materialFont.load()
      setIconFontLoaded(true)
    } catch {
      // console.log('error')
    }
  }

  useEffect(() => {
    if (!isIconFontLoaded) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      loadMaterialIconsFontOnStart()
    }
  }, [isIconFontLoaded])
}
